import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { goodsService } from 'shared/src/api';

export const useRankingFilters = () => {
  return useSuspenseQuery({
    queryKey: queryKey.rankingFilters(),
    queryFn: () => goodsService.getRankingFilters(),
  });
};